export const TAGS_UPDATED_EVENT = 'tags-updated';
